import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ADDRESS_STEP, CHECKOUT_STEP_MAP } from 'constants/checkoutFlow';

import Address from 'components/checkout/caap/address/Address';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';
import css from 'styles/components/checkout/caap/address/shippingAddress.scss';

const ShippingAddress = ({ address, onChangeAddressClick, purchaseId }, { testId }) => (
  <div>
    <Row desktopOnly={true}>
      <RowSpan span="4">
        <div className={css.inactiveTitleBar}>
          <div className={css.titleWrapper}>
            <div className={css.stepIndex}>
              <h3>1</h3>
            </div>
            <h4 className={css.title}>Shipping address</h4>
          </div>
        </div>
      </RowSpan>
      <RowSpan span="6">
        { <Address address={address} multiLineDisplay={true} isBaseForHighlight={true} /> }
      </RowSpan>
      <RowSpan span="2">
        <div className={css.changeSectionContainer}>
          <Link
            onClick={onChangeAddressClick}
            to={`${CHECKOUT_STEP_MAP[ADDRESS_STEP]}?referrer=spc&pid=${purchaseId}`}
            data-test-id={testId('changeShipAddress')}>Change</Link>
        </div>
      </RowSpan>
    </Row>

    <Row mobileOnly={true}>
      <Link onClick={onChangeAddressClick} to={`${CHECKOUT_STEP_MAP[ADDRESS_STEP]}?referrer=spc&pid=${purchaseId}`} data-test-id={testId('changeShipAddress')}>
        <Row>
          <RowSpan span="10">
            { <Address address={address} /> }
          </RowSpan>
          <RowSpan span="2">
            <RightArrow />
          </RowSpan>
        </Row>
      </Link>
    </Row>
  </div>
);

ShippingAddress.contextTypes = {
  testId: PropTypes.func
};

export default ShippingAddress;
